import React from "react";
import { MockupSlot } from "./MockupSlot";
import { bonuses } from "../data/landing";
export function BonusSection() {
  return <section id="bonus" className="bg-cream" data-id="element-12" data-mp="1ofc4nrlz6nfw">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-13" data-mp="22fd5x865jwvw">
        <div className="mx-auto max-w-3xl text-center" data-id="element-14" data-mp="22etxqj6b0mv2">
          <h2 className="font-display text-3xl font-semibold leading-tight text-ink md:text-[2.6rem]" data-id="element-15" data-mp="1ydrwxxwqo2qz">
            Et pour aller encore plus loin… découvrez vos 4 bonus !
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-16" data-mp="15pm8p16h7vme">
            Des ressources complémentaires pour intégrer la foi dans les petits
            moments du quotidien.
          </p>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 md:mt-16 lg:grid-cols-4" data-id="element-17" data-mp="1eozm24xq14ce">
          {bonuses.map(bonus => <li key={bonus.label} className="flex flex-col rounded-3xl bg-white p-4 ring-1 ring-ink/10" data-id="element-18" data-mp="qywzg4cksql6">
              <MockupSlot src={bonus.cover} label={`Couverture — ${bonus.label}`} hint="Couverture réelle à intégrer" className="aspect-[4/5] w-full" data-id="element-19" data-mp="29scs311llugc" />
              <div className="flex flex-1 flex-col px-1 pb-1 pt-5" data-id="element-20" data-mp="2jixqandd0wyq">
                <p className="text-xs font-extrabold tracking-widest text-terracotta" data-id="element-21" data-mp="2ogpqe4o5rpe0">
                  {bonus.label.toUpperCase()}
                </p>
                <h3 className="mt-2 font-display text-lg font-semibold uppercase leading-snug text-ink lg:min-h-[4.5rem]" data-id="element-22" data-mp="1qus6c2u4rbzy">
                  {bonus.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-soft" data-id="element-23" data-mp="20qd9w5eukkbt">
                  {bonus.text}
                </p>
                <p className="mt-5 text-sm font-bold text-sage-deep" data-id="element-24" data-mp="25rsu5v97amt5">
                  Inclus dans le Méga Pack
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}